export default "__VITE_ASSET__CVNc91Tg__"